import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import TrainingsContent from '../../components/Pages/Trainings';

const { displayName } = config;

export default function Trainings(): React.ReactNode | null {
  document.title = `${displayName}: Тренировки`;

  return (
    <Layout>
      <TrainingsContent />
    </Layout>
  );
}
